// extracted by mini-css-extract-plugin
module.exports = {"presentationBox":"hero-module--presentationBox--pv_gv","presentation":"hero-module--presentation--2eg4h","img":"hero-module--img--1JfTK"};